import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import ZRMUtils from '@zg-rentals/zrm-utils-js/lib/utils';

import { RMWContext } from 'app/shared/providers/RMWContext';

import analyticsUtils from 'app/client/utils/analyticsUtils';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';

import {
    FormField,
    Label,
    PageBreadcrumb,
    Spacer,
    Text,
    TextButton,
} from '@zillow/constellation';

import {
    Col,
    Container,
    Row,
} from '@zillow/zrs-comet';

import BillingActions from 'app/shared/actions/BillingActions';

import { INVOICE_PAYMENTS } from 'app/shared/constants/RouteConstants';

import PermissionCheck from 'app/shared/components/PermissionCheck';
import HeadWrapper from 'app/shared/components/HeadWrapper';
import BillingPaymentMethods from 'app/shared/components/Billing/BillingPaymentMethods';
import { withErrorBoundary } from 'app/shared/components/ErrorBoundary';

import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

const propTypes = {};

const PAGE_TITLE = 'Edit Auto Pay Settings';

// Stylesheets
import '../InvoicePage/style.scss';
import { StyledAccountSettingsContainer } from './StyledComponents';

const AccountPaymentPage = ({
    dispatch,
    match,
}) => {
    const { paths } = React.useContext(RMWContext);
    const location = useLocation();
    const queryParams = ZRMUtils.queryUtils.parse(location.search);
    const accountName = useSelector(state => state.billing.accountPaymentMethods.accountName);

    const handleSubmit = (selectedCreditCardId, autopayEnabled) => {
        if (autopayEnabled) {
            dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.BILLING_PORTAL_ADD_AUTOPAY));
            return dispatch(BillingActions.saveDefaultPaymentMethod({
                accountNumber: match.params.accountNumber,
                defaultPaymentMethodId: selectedCreditCardId,
                autopayEnabled,
            })).catch(() => {
                // Todo handle error
            });
        }
        dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.BILLING_PORTAL_REMOVE_AUTOPAY));
        return dispatch(BillingActions.removeAutopay({
            accountNumber: match.params.accountNumber,
        })).catch(() => {
            // Todo handle error
        });
    };

    const getBackText = () => {
        switch (queryParams.prev) {
            case 'invoice':
                return 'Back to Invoice';
            case 'settings':
            default:
                return 'Back To Settings';
        }
    };

    const getBackLink = () => {
        switch (queryParams.prev) {
            case 'invoice':
                return `${paths.billingPage}/${paths.invoicePage}/${queryParams.invoiceNumber}`;
            case 'settings':
            default:
                return '/rental-manager/billing/paymentSettings';
        }
    };

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <PermissionCheck route={INVOICE_PAYMENTS}>
                <div className="AccountPaymentPage">
                    <HeadWrapper title={PAGE_TITLE} />
                    <Container>
                        <PageBreadcrumb
                            backButton={(
                                <TextButton
                                    as={Link}
                                    to={getBackLink()}
                                >
                                    {getBackText()}
                                </TextButton>
                            )}
                        />
                        <StyledAccountSettingsContainer>
                            <Spacer padding="sm">
                                <Container style={{ padding: 0 }}>
                                    <Row>
                                        <Col xs={12} md={6}>
                                            <Text fontType="h4">
                                                {PAGE_TITLE}
                                            </Text>
                                            <Spacer paddingBottom="lg" />
                                            <FormField>
                                                <Label>
                                                    ACCOUNT:
                                                </Label>
                                                {accountName}
                                            </FormField>
                                            <Spacer paddingBottom="md" />
                                            <BillingPaymentMethods
                                                accountNumber={match.params.accountNumber}
                                                onSubmit={handleSubmit}
                                                allowRemove={true}
                                            />
                                        </Col>
                                    </Row>
                                </Container>
                            </Spacer>
                        </StyledAccountSettingsContainer>
                    </Container>
                </div>
            </PermissionCheck>
        </AuthCheckWrapper>
    );
};

AccountPaymentPage.propTypes = propTypes;

export { AccountPaymentPage };
export default withErrorBoundary(connect()(AccountPaymentPage));
